import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #CARD
\*------------------------------------ */
/**
 * 1) A card is an organized block that typically contains a title, image,
 * text, and/or calls to action. It is made up of a required body slot and optional
 * footer slot to place other components and content within.
 */
.cat-c-card {
  display: var(--cat-card-display, flex);
  flex-flow: var(--cat-card-flex-direction, column) wrap;
  width: 100%;
  height: 100%;
  padding: var(--cat-card-padding, var(--cat-space-medium));
  border-width: var(--cat-border-width-sm);
  border-style: solid;
  border-color: var(--cat-card-border-color, var(--cat-theme-color-border-default));
  border-radius: var(--cat-border-radius-lg);
  background-color: var(--cat-theme-color-background-default);
}

/**
 * Card that renders as a link
 */
a.cat-c-card {
  color: inherit;
  text-decoration: none;
  cursor: pointer;
}

/**
 * Card that renders with no padding
 */
.cat-c-card--remove-padding {
  padding: 0;
}

/**
* Bare card
* 1) Remove border and padding so that it's flush with the grid item
*/
.cat-c-card--bare {
  border: 0;
  padding: 0;
  border-radius: 0;
  box-shadow: none;
  background: none;
}

/**
 * Card header
 */
.cat-c-card__header {
  margin-block-end: var(--cat-space-medium);
}
.cat-c-card--remove-padding .cat-c-card__header {
  margin-block-end: 0;
}

.cat-c-card__header:empty {
  display: none;
}

/**
 * Card body
 * 1) Flex applied to always fill the remaining space of the card
 */
.cat-c-card__body {
  display: block;
  flex: 1 0 auto;
  max-width: 100%;
}

/**
 * Card footer
 */
.cat-c-card__footer {
  display: block;
  width: 100%;
  margin-block-start: var(--cat-space-medium);
}
.cat-c-card--remove-padding .cat-c-card__footer {
  margin-block-start: 0;
}

/**
 * Bare on mobile
 * 1) Remove border and padding on mobile
 */
@media all and (max-width: 48rem) {
  .cat-c-card--bare-on-mobile {
    border: none;
    padding: 0;
  }
}

.cat-c-card:not(.cat-c-card--has-header-slot) [part=header-wrapper], .cat-c-card:not(.cat-c-card--has-footer-slot) [part=footer-wrapper] {
  display: none;
}
`;
       